var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'OrganizationHome'
      }
    }
  }, [_vm._v(" 組織資料設定 ")]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'MarketingRuleList'
      }
    }
  }, [_vm._v("行銷規則列表 ")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(_vm._s(_vm.isReadOnly ? "查看行銷規則" : _vm.isEditing ? "編輯行銷規則" : "新增行銷規則") + " ")])], 1)], 1)])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-6 mb-2 mb-xl-0 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.isReadOnly ? "查看行銷規則" : _vm.isEditing ? "編輯行銷規則" : "新增行銷規則") + " ")]), _c('div', {
    staticClass: "col-12 col-xl-8 mt-3"
  }, [_vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "通路"
    }
  }, [_c('b-form-select', {
    attrs: {
      "disabled": _vm.isReadOnly,
      "options": _vm.merchants
    },
    model: {
      value: _vm.merchantId,
      callback: function callback($$v) {
        _vm.merchantId = $$v;
      },
      expression: "merchantId"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "比對關鍵字"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.rule.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.rule, "keyword", $$v);
      },
      expression: "rule.keyword"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "比對類型"
    }
  }, [_c('b-form-select', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "options": _vm.matchedTypeOptions,
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.rule.matched_type,
      callback: function callback($$v) {
        _vm.$set(_vm.rule, "matched_type", $$v);
      },
      expression: "rule.matched_type"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "比對順序"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.rule.order,
      callback: function callback($$v) {
        _vm.$set(_vm.rule, "order", $$v);
      },
      expression: "rule.order"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "比對目標"
    }
  }, [_c('b-form-select', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "options": _vm.matchedCodeOptions,
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.rule.matched_code,
      callback: function callback($$v) {
        _vm.$set(_vm.rule, "matched_code", $$v);
      },
      expression: "rule.matched_code"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "轉換內容"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.rule.convert_value,
      callback: function callback($$v) {
        _vm.$set(_vm.rule, "convert_value", $$v);
      },
      expression: "rule.convert_value"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "轉換比例"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.rule.convert_ratio,
      callback: function callback($$v) {
        _vm.$set(_vm.rule, "convert_ratio", $$v);
      },
      expression: "rule.convert_ratio"
    }
  })], 1)], 1)]), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("返回 ")]), !_vm.isReadOnly ? _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("儲存")]) : _vm._e()], 1)])], 1)], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }